import {
	Button,
	CardContent,
	Container,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	Typography,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import moment from "moment";
import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import CommCard from "src/common/CommCard";
import CommonPdfAndImageView from "src/common/CommonPdfAndImageView";
import DetailsDataShowByGrid from "src/common/DetailsDataShowByGrid";
import EditCommIcon from "src/common/EditCommIcon";
import GlobalLoader from "src/components/SuspenseLoader/GlobalLoader";
import { url } from "src/Helpers/utils/constants";
import { useApiQuery } from "src/hooks/useApiQuery";
import { getStatusLabel } from "src/Utils/Combined";
import { ISingleProductByExhibitor } from "src/Utils/type";
import SingleProductUpdateForm from "./SingleProductUpdateForm";

const ExhibitorSingleProduct = () => {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const { ExhibitorSingleProduct, singleMemberFairId } = useParams();
	const { data, isLoading } = useApiQuery<ISingleProductByExhibitor>({
		endPoint: `${url}/api/fair/get/single/fair-member-product/by/${singleMemberFairId}/${ExhibitorSingleProduct}`,
		queryKeys: ["singleProduct"],
	});

	return (
		<CommCard helmetTitle='BTTF - Single exhibitor product information'>
			<Container sx={{ my: 2 }} maxWidth='xl'>
				<Grid
					container
					spacing={{ xs: 2, md: 3 }}
					columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
				>
					{!isLoading ? (
						<Container>
							<Box sx={{ py: 2 }}>
								<Button onClick={() => navigate(-1)}>
									Go back
								</Button>
							</Box>
							<>
								<EditCommIcon handleClick={handleOpen} />
								<CardContent>
									<Box key={data?.fair_member_product_id}>
										<Typography
											textAlign='center'
											gutterBottom
											variant='h2'
											component='div'
										>
											Exhibitor Product Information
										</Typography>

										<Box>
											<Grid
												container
												spacing={{ xs: 2, md: 3 }}
											>
												<Grid item xs={12}>
													{data?.fair_member_product_photo?.map(
														(photo, index) => (
															<CommonPdfAndImageView
																key={index}
																file={photo}
																fileName={`Product-${
																	index + 1
																}`}
															/>
														)
													)}
												</Grid>
											</Grid>

											<DetailsDataShowByGrid
												fields={[
													{
														label: "Product Name",
														value: data?.fair_member_product_name,
													},
													{
														label: "Product Category",
														value: data?.fair_member_product_category,
													},
													{
														label: "Product Price",
														value: data?.fair_member_product_price,
													},
													{
														label: "Product Special Price",
														value: data?.fair_member_special_product_price,
													},
													{
														label: "Product Description",
														value: data?.fair_member_product_description,
													},
													{
														label: "Product URL",
														value: data?.fair_member_product_url ? (
															<a
																href={
																	data?.fair_member_product_url
																}
																target='_blank'
																rel='noopener noreferrer'
															>
																Website Link
															</a>
														) : (
															"N/A"
														),
													},
													{
														label: "Product Created Date",
														value: data?.user_fair_member_product_created_at
															? moment(
																	data?.user_fair_member_product_created_at
															  ).format("LL")
															: "N/A",
													},
													{
														label: "Product Updated Date",
														value: data?.user_fair_member_product_updated_at
															? moment(
																	data?.user_fair_member_product_updated_at
															  ).format("LL")
															: "N/A",
													},
													{
														label: "Product Status",
														value: getStatusLabel(
															data?.user_fair_member_product_status
														),
													},
												]}
											/>
										</Box>
										<Dialog
											fullScreen={fullScreen}
											open={open}
											onClose={handleClose}
											aria-labelledby='responsive-dialog-title'
										>
											<DialogTitle
												sx={{ p: 2 }}
												id='responsive-dialog-title'
											>
												<Typography variant='h4'>
													Product Status Update{" "}
												</Typography>
											</DialogTitle>
											<DialogContent>
												{/* <ExhibitorInvoiceUpdateForm
                              details={singleProductExhibitor}
                              setReload={setReload}
                              handleClose={handleClose}
                            /> */}
												<SingleProductUpdateForm
													details={data}
													handleClose={handleClose}
												/>
											</DialogContent>
											<DialogActions>
												<Button
													autoFocus
													onClick={handleClose}
												>
													Close
												</Button>
											</DialogActions>
										</Dialog>
									</Box>
								</CardContent>
							</>
						</Container>
					) : (
						<GlobalLoader />
					)}
				</Grid>
			</Container>
		</CommCard>
	);
};

export default ExhibitorSingleProduct;
